import { InformationCircleIcon } from '@heroicons/react/24/outline'

export default () => (
  <div className="badge badge-outline badge-accent p-1 h-fit">
    <InformationCircleIcon className="h-4 w-4" />
    <span>Le RIB du compte séquestre de l'agence est disponible en pied de page.</span>
  </div>
)